// import styled from "@emotion/styled";
import { Box, Typography } from "@mui/material";
import { useRef } from "react";
import { useEffect, useState } from "react";

// const StyledBox = styled(Box)(({theme}) => ({
//     minWidth: '400px',
//     minHeight: '200px',
// }))

/**
 * 
 * @param {object} props
 * @param {string} props.title 
 * @param {object} props.onPaste callback function which expects blob as parameter. Executed after user pastes a file.  
 * @param {string} props.sx 
 * @param {object} props.children
 *  
 * @returns 
 */
export default function ImagePasteBox({title = 'To upload a screenshot paste it here (Ctrl-V)', onPaste, sx, children}) {

    const pasteBox = useRef()
    // const [pastedBlobObjectUrls, setPastedBlobObjectUrls] = useState([])
    const [noFileWasPasted, setNoFileWasPasted] = useState(false)

    useEffect(() => {
        const pasteListener = (evt) => {
            const clipboardItems = evt.clipboardData.items;
            const items = [].slice.call(clipboardItems).filter(function (item) {
                // Filter the image items only
                return item.type.indexOf('image') !== -1
            });
            if (items.length === 0) {
                setNoFileWasPasted(true)
                return
            }
            const item = items[0]
            const blob = item.getAsFile()

            // const blobObjectUrl = URL.createObjectURL(blob)
            // setPastedBlobObjectUrls([blobObjectUrl])
            setNoFileWasPasted(false)
            onPaste(blob)
        }

        document.addEventListener('paste', pasteListener)

        return () => {
            document.removeEventListener('paste', pasteListener)
        }

    })

    const handlePaste = (event) => {
        event.preventDefault()
        console.log('Box paste')
    }

    return (
        <Box sx={sx} onPaste={handlePaste} ref={pasteBox}>
                <Typography sx={{pt:1, pl:1}} variant="body2">{noFileWasPasted ? 'Try pasting a screenshot' : title}</Typography>
                {
                    children
                }
                {/* { 
                    pastedBlobObjectUrls.map((item,i) => (
                        <div className="img" key={`some-key-${i}`} >
                            <img alt="pasted" id={`some-id-${i}`} src={item} />
                        </div>
                    ))
                } */}
        </Box>
    )
}
